import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cloutLogo from '../../assets/logos/clout-logo.png';
import SearchIcon from '../icons/SearchIcon';
import NotificationIcon from '../icons/NotificationIcon';
import UserIcon from '../icons/UserIcon';

const ProviderProfileHeader: React.FC = () => {
  const navigate = useNavigate();
  const [showMobileSearch, setShowMobileSearch] = useState(false);

  return (
    <header className="bg-[#f8f6f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3 sm:py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img src={cloutLogo} alt="CLOUT Aesthetics" className="h-10 sm:h-12 lg:h-14" />
          </div>

          {/* Search Bar - Hidden on mobile, visible on md+ */}
          <div className="hidden md:flex flex-1 max-w-lg mx-4 lg:mx-8">
            <div className="relative w-full">
              <input
                type="text"
                placeholder="Search for providers"
                className="w-full px-4 py-2 pr-10 text-sm font-['Open_Sans'] text-[#1f1f1f] placeholder-[#767472] bg-white border border-[#c6a664] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#c6a664] focus:border-transparent"
              />
              <button className="absolute right-2 top-1/2 transform -translate-y-1/2">
                <SearchIcon />
              </button>
            </div>
          </div>

          {/* Right Icons */}
          <div className="flex items-center space-x-2 sm:space-x-4">
            {/* Mobile search toggle */}
            <button
              onClick={() => setShowMobileSearch(!showMobileSearch)}
              className="md:hidden p-2 hover:bg-white/50 rounded-full transition-colors"
            >
              <SearchIcon />
            </button>
            <button className="p-2 hover:bg-white/50 rounded-full transition-colors">
              <NotificationIcon />
            </button>
            <button
              onClick={() => navigate('/profile')}
              className="p-2 hover:bg-white/50 rounded-full transition-colors"
            >
              <UserIcon />
            </button>
          </div>
        </div>

        {/* Mobile Search Bar - Expandable */}
        {showMobileSearch && (
          <div className="md:hidden pb-3">
            <div className="relative">
              <input
                type="text"
                placeholder="Search for providers"
                className="w-full px-4 py-2 pr-10 text-sm font-['Open_Sans'] text-[#1f1f1f] placeholder-[#767472] bg-white border border-[#c6a664] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#c6a664] focus:border-transparent"
                autoFocus
              />
              <button className="absolute right-2 top-1/2 transform -translate-y-1/2">
                <SearchIcon />
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default ProviderProfileHeader;
